export const BalanceSheetClassificationType = Object.freeze({
  equity: 0,
  assets: 1,
  expense: 2,
  revenue: 3,
  liabilities: 4,
});

export const BalanceSheetClassificationTypeLabels = Object.freeze({
  [BalanceSheetClassificationType.equity]: 'equity',
  [BalanceSheetClassificationType.assets]: 'asset',
  [BalanceSheetClassificationType.expense]: 'expense',
  [BalanceSheetClassificationType.revenue]: 'revenue',
  [BalanceSheetClassificationType.liabilities]: 'liability',
});

export const BalanceSheetClassificationTypeEmptyStateMessage = Object.freeze({
  [BalanceSheetClassificationTypeLabels[BalanceSheetClassificationType.equity]]:
    'No more information on equities',
  [BalanceSheetClassificationTypeLabels[BalanceSheetClassificationType.assets]]:
    'No more information on assets',
  [BalanceSheetClassificationTypeLabels[BalanceSheetClassificationType.expense]]:
    'No more information on expenses',
  [BalanceSheetClassificationTypeLabels[BalanceSheetClassificationType.revenue]]:
    'No more information on revenues',
  [BalanceSheetClassificationTypeLabels[BalanceSheetClassificationType.liabilities]]:
    'No more information on liabilities',
});

export const BalanceSheetAccountType = Object.freeze({
  fixedAssets: 0,
  debtors: 1,
  bank: 5,
  shortTermLiability: 6,
  longTermLiability: 10,
  equity: 11,
});

export const BalanceSheetAccountTypeLabels = Object.freeze({
  [BalanceSheetAccountType.equity]: 'equity',
  [BalanceSheetAccountType.bank]: 'bank',
  [BalanceSheetAccountType.debtors]: 'current assets',
  [BalanceSheetAccountType.fixedAssets]: 'fixed assets',
  [BalanceSheetAccountType.shortTermLiability]: 'current liability',
  [BalanceSheetAccountType.longTermLiability]: 'long term liability',
});

export const BalanceSheetAccountTypesInfo = Object.freeze({
  [BalanceSheetAccountTypeLabels[BalanceSheetAccountType.fixedAssets]]: [
    'Release cash from existing assets',
    'Fund a new purchase',
  ],
  [BalanceSheetAccountTypeLabels[BalanceSheetAccountType.debtors]]: [
    'Release cash',
    'Insure risk of bad debts',
  ],
});

export const InsightCardClassificationMinimumValue = Object.freeze({
  [BalanceSheetClassificationType.liabilities]: 20000,
});

export const InsightCardAccountTypeMinimumValue = Object.freeze({
  [BalanceSheetAccountType.shortTermLiability]: 20000,
  [BalanceSheetAccountType.fixedAssets]: 50000,
  [BalanceSheetAccountType.debtors]: 50000,
  [BalanceSheetAccountType.bank]: 50000,
});

export const BalanceSheetClassificationPriorities = Object.freeze({
  [BalanceSheetClassificationTypeLabels[BalanceSheetClassificationType.assets]]: 3,
  [BalanceSheetClassificationTypeLabels[BalanceSheetClassificationType.liabilities]]: 2,
  [BalanceSheetClassificationTypeLabels[BalanceSheetClassificationType.equity]]: 1,
  [BalanceSheetClassificationTypeLabels[BalanceSheetClassificationType.revenue]]: 0,
  [BalanceSheetClassificationTypeLabels[BalanceSheetClassificationType.expense]]: 0,
});

export const getBalanceSheetAccountTypesInfo = (view) => {
  const key = Object.keys(BalanceSheetAccountTypesInfo).find((k) => k.includes(view));
  return BalanceSheetAccountTypesInfo[key] || [];
};

export const getBalanceSheetEmptyStateMessage = (classification) => {
  const key = Object.keys(BalanceSheetClassificationTypeEmptyStateMessage).find((k) =>
    k.includes(classification),
  );
  return BalanceSheetClassificationTypeEmptyStateMessage[key] || '';
};
